import * as actionTypes from "../types";

export const setPagerefresh = (data) => {
    return {
      type: actionTypes.SET_PAGE_REFRESH,
      payload: data
    };
  };